import React from "react";
import { assetsPath } from "../../../utils";

const path = assetsPath();

export default () => (
  <svg viewBox="0 0 512 512" width={150} height={150} x={-150} y={0}>
    <image
      xlinkHref={`${path}/images/project-map/laguna-beachside-bubble.svg`}
      width={512}
      height={512}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/pages/LagunaBeachside/components/Bubble.js